import type { JobOfferEmbedDetailsShowingV2ResponseDto, Process } from "@/lib/interfaces/embed";
import type { IframeSettingsDesignDraft, IframeSettingsTextDraft } from "./IframeSettingsPreviewContext";

export function mergeJobPreviewPayload(
  base: JobOfferEmbedDetailsShowingV2ResponseDto,
  design: IframeSettingsDesignDraft,
  text: IframeSettingsTextDraft,
): JobOfferEmbedDetailsShowingV2ResponseDto {
  const color = design.color?.trim() ? design.color : base.organization.color;
  const organization = { ...base.organization, color };

  let jobOfferPreview = { ...base.jobOfferPreview };
  if (design.showImage === false) {
    jobOfferPreview = { ...jobOfferPreview, showImage: false };
  }

  let similarJobs = base.similarJobs;
  if (design.showImage === false && similarJobs?.length) {
    similarJobs = similarJobs.map((j) => ({ ...j, showImage: false }));
  }

  let process: Process | undefined = base.process;
  if (text.processTitle?.trim() || (text.processCards?.length ?? 0) > 0) {
    process = {
      title: text.processTitle?.trim() || base.process?.title || "Unser Bewerbungsprozess",
      processCards: (text.processCards?.length ?? 0) > 0 ? text.processCards : base.process?.processCards,
    };
  }

  const embedSettings = {
    ...(base.embedSettings ?? {}),
    heroEyebrowText: text.heroEyebrowText?.trim() || "",
  };

  return {
    ...base,
    organization,
    jobOfferPreview,
    similarJobs,
    process,
    embedSettings,
  };
}
